export default {
  easy: {
    name: '简单',
    col: 6,
    row: 8,
    mineProbability: 0.1
  },
  general: {
    name: '普通',
    row: 18,
    col: 14,
    mineProbability: 0.12
  },
  hard: {
    name: '困难',
    col: 16,
    row: 30,
    mineProbability: 0.15
  },
  blockWidth: 25,
  blockHeight: 25
}
